export const testimonial1 = [
  {
    id: 1,
    avatar: "/img/avatars/testimonials/1.png",
    name: "Maja",
    designation: "Studentka",
    text: `Studiuję dziennie i dzięki temu mogę cieszyć się dużą elastycznością co do tego co mogę robić w wakacje.
    tripsi nie tylko pomaga mi znaleźć okazyjne oferty podróży, ale przede wszystkim daje mnóstwo inspiracji gdzie mogę
    polecieć za rozsądne pieniądze`,
    dealyAnimation: "100",
  },
  {
    id: 3,
    avatar: "/img/avatars/testimonials/3.png",
    name: "Bruno",
    designation: "Freelancer",
    text: `Jestem freelancerem i uwielbiam podróżować. Jednak szukanie ofert za sensowne pieniądze było dla mnie nielada wyzwaniem, gdyż większość 
    wyszukiwarek ma umiarkowane wsparcie dla elastycznych terminów, a przede wszystkim nie biorą pod uwagę kosztów zakwaterowania. W tripsi mogę znaleźć 
    wyjazdy odpowiednie na moją kieszeń i idealne na tzw. workation`,
    dealyAnimation: "300",
  },
  {
    id: 2,
    avatar: "/img/avatars/testimonials/2.png",
    name: "Nela",
    designation: "Studentka",
    text: `tripsi to świetne miejsce dla osób które są choć trochę elastyczne w terminie wyjazdu. Co prawda nie znajdziemy tutaj 
    absurdalnie tanich wycieczek np. na długie weekendy lub najbardziej oblegane terminy, ale jeśli jesteś elastyczny w kwestii terminów,
    to jest to z pewnością najlepsza wyszukiwarka wakacji z jakiej miałam okazję korzystać`,
    dealyAnimation: "200",
  },
  // {
  //   id: 4,
  //   avatar: "/img/avatars/testimonials/1.png",
  //   name: "Annette Black",
  //   designation: "UX / UI Designer",
  //   text: `The place is in a great location in Gumbet. The area is safe and
  //       beautiful. The apartment was comfortable and the host was kind and
  //       responsive to our requests. Really a nice place.`,
  //   dealyAnimation: "400",
  // },
];
export const testimonial2 = [
  {
    id: 1,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/1.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "100",
  },
  {
    id: 2,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/2.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "200",
  },
  {
    id: 3,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/3.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "300",
  },
  {
    id: 4,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/4.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "400",
  },
  {
    id: 5,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/5.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "500",
  },
];

export const testimonial3 = [
  {
    id: 1,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/1.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 2,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/2.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 3,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/3.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 4,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/4.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 5,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/5.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
];
